// components/ui/password-input.tsx
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../../lib/utils";
import { Input } from "./input";

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [show, setShow] = useState(false);

    return (
      <div data-component-id="src/components/ui/PasswordInput.tsx:14:6" data-component-path="src/components/ui/PasswordInput.tsx" data-component-line="14" data-component-file="PasswordInput.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
        <Input data-component-id="src/components/ui/PasswordInput.tsx:15:8" data-component-path="src/components/ui/PasswordInput.tsx" data-component-line="15" data-component-file="PasswordInput.tsx" data-component-name="Input" data-component-content="%7B%22elementName%22%3A%22Input%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
          ref={ref}
          type={show ? "text" : "password"}
          className={cn("pr-10", className)}
          {...props}
        />
        <button data-component-id="src/components/ui/PasswordInput.tsx:21:8" data-component-path="src/components/ui/PasswordInput.tsx" data-component-line="21" data-component-file="PasswordInput.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22button%22%2C%22className%22%3A%22absolute%20right-3%20top-1%2F2%20-translate-y-1%2F2%20cursor-pointer%20text-muted-foreground%20hover%3Atext-foreground%22%7D"
          type="button"
          tabIndex={-1}
          onClick={() => setShow(!show)}
          className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-muted-foreground hover:text-foreground"
        >
          {show ? <Eye data-component-id="src/components/ui/PasswordInput.tsx:27:18" data-component-path="src/components/ui/PasswordInput.tsx" data-component-line="27" data-component-file="PasswordInput.tsx" data-component-name="Eye" data-component-content="%7B%22elementName%22%3A%22Eye%22%2C%22className%22%3A%22w-4%20h-4%22%7D" className="w-4 h-4" /> : <EyeOff data-component-id="src/components/ui/PasswordInput.tsx:27:48" data-component-path="src/components/ui/PasswordInput.tsx" data-component-line="27" data-component-file="PasswordInput.tsx" data-component-name="EyeOff" data-component-content="%7B%22elementName%22%3A%22EyeOff%22%2C%22className%22%3A%22w-4%20h-4%22%7D" className="w-4 h-4" />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";
